import { HttpErrorResponse } from '@angular/common/http';
import { ApiException, ApiExceptionConstructor } from 'src/core/common/domain/exceptions/api-exception';

export class TimeoutException extends ApiException implements ApiExceptionConstructor {
  constructor(message?: string, error?: HttpErrorResponse | Error) {
    super(message, error);
    this.name = 'TimeoutException';
  }

  static fromError(error: HttpErrorResponse | Error): TimeoutException {
    return new this(error.message, error);
  }
}
